import 'focus-visible/dist/focus-visible.min'

// https://jira.si.fr.intraorange/browse/FTACCUEILV-3198
// Si title existant, compléter la propriété title avec le suffixe " (nouvelle fenêtre)"
// Si title inexistant, reprendre le libellé du lien pour alimenter la propriété title et la compléter du même suffixe" (nouvelle fenêtre)"
// Redonder la propriété title obtenue avec la propriété aria-label toujours avec le suffixe "... (nouvelle fenêtre)"
export function accessibility () {
  const suffix = ' ' + '(nouvelle fenêtre)'

  document.querySelectorAll('body > .site-width a[target=_blank]').forEach( blankLink => {
    let attrTitle = blankLink.title
    let attrAria = blankLink.getAttribute('aria-label')
    let attrText = blankLink.text
    attrText = attrText.trim() // remove linebreaks and extra spaces
    let textSuffix = attrText + suffix

    if (attrTitle == '') {
      blankLink.title = textSuffix
    } else {
      blankLink.title += suffix
    }

    if (attrAria == '' || attrAria == null) {
      blankLink.setAttribute('aria-label', textSuffix)
    } else {
      blankLink.setAttribute('aria-label', attrAria + suffix)
    }
  })
}
